import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  font-family: Spoqa Han Sans Neo;
`;

const CaseNumberBox = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 700;
  color: white;
  background-color: #000;
`;
const CourtName = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.64);
`;
const SummaryBox = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
`;
const Block = styled.div<{
  flexDir: 'row' | 'column';
  paddingB?: number;
  borderB?: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => props.flexDir};
  align-items: ${(props) =>
    props.flexDir === 'row' ? 'center' : 'flex-start'};
  gap: 8px;
  padding-bottom: ${(props) => (props.paddingB ? `${props.paddingB}px` : '0')};
  border-bottom: ${(props) =>
    props.borderB ? '1px solid rgba(112, 115, 124, 0.16)' : 'none'};
  flex-wrap: wrap;
`;
const ItemTypeChip = styled.span`
  width: 42px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
`;
const AddressBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const JiBunAddressBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;
const JibunAddress = styled.div`
  flex: 1;
  flex-wrap: wrap;
`;
const CopyButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  color: #008aff;
  cursor: pointer;
`;
const RoadAddress = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #616161;
`;
const SaleDate = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;
const Divider = styled.div`
  width: 1px;
  height: 24px;
  background-color: rgba(112, 115, 124, 0.16);
`;
const BidInfoItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  color: #616161;
`;
const BidInfoContent = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #222;
`;
const PriceBox = styled.div`
  width: calc((100% - 8px) / 2);
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 400;
  line-height: 145%;
  color: #616161;
  border-radius: 8px;
  background-color: #f7f8fc;
`;
const Price = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222;
`;
const InterestButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const InterestButton = styled.div`
  flex: 1;
  padding: 18px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  cursor: pointer;
`;

export const s = {
  Container,
  CaseNumberBox,
  CourtName,
  SummaryBox,
  Block,
  ItemTypeChip,
  AddressBox,
  JiBunAddressBox,
  JibunAddress,
  CopyButton,
  RoadAddress,
  SaleDate,
  Divider,
  BidInfoItem,
  BidInfoContent,
  PriceBox,
  Price,
  InterestButtonBox,
  InterestButton,
};
